var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 2.00001C4.68625 2.00001 1.99996 4.6863 1.99996 8.00001C1.99996 11.3137 4.68625 14 7.99996 14C11.3137 14 14 11.3137 14 8.00001C14 4.6863 11.3137 2.00001 7.99996 2.00001ZM0.666626 8.00001C0.666626 3.94992 3.94987 0.666672 7.99996 0.666672C12.05 0.666672 15.3333 3.94992 15.3333 8.00001C15.3333 12.0501 12.05 15.3333 7.99996 15.3333C3.94987 15.3333 0.666626 12.0501 0.666626 8.00001Z",
    fill: "#07364B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 8.00001C0.666626 7.63182 0.965103 7.33334 1.33329 7.33334H14.6666C15.0348 7.33334 15.3333 7.63182 15.3333 8.00001C15.3333 8.3682 15.0348 8.66668 14.6666 8.66668H1.33329C0.965103 8.66668 0.666626 8.3682 0.666626 8.00001Z",
    fill: "#07364B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00011 8C6.0458 10.0499 6.7508 12.0234 7.99996 13.6328C9.24912 12.0234 9.95411 10.0499 9.9998 8C9.95411 5.9501 9.24912 3.97656 7.99996 2.36719C6.7508 3.97656 6.0458 5.9501 6.00011 8ZM7.99996 1.33333L7.50773 0.883713C5.73122 2.8286 4.72163 5.35256 4.66677 7.98611C4.66658 7.99537 4.66658 8.00462 4.66677 8.01388C4.72163 10.6474 5.73122 13.1714 7.50773 15.1163C7.63404 15.2546 7.81268 15.3333 7.99996 15.3333C8.18724 15.3333 8.36588 15.2546 8.49219 15.1163C10.2687 13.1714 11.2783 10.6474 11.3331 8.01388C11.3333 8.00462 11.3333 7.99537 11.3331 7.98611C11.2783 5.35256 10.2687 2.8286 8.49219 0.883713L7.99996 1.33333Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a403096c5646fb3ea62fca142e35fb57.svg";
export { ForwardRef as ReactComponent };